/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 18,
    height: 32,
    viewBox: '0 0 18 32',
    data: '<path pid="0" d="M2.23 32c.619 0 1.145-.222 1.579-.667l13.47-13.81c.991-1.015.96-2.063-.093-3.142L3.81.667A2.124 2.124 0 002.229 0C1.61 0 1.085.222.65.667.217 1.11 0 1.65 0 2.286S.217 3.46.65 3.905L12.45 16 .65 28.095c-.433.445-.65.984-.65 1.62 0 .634.217 1.174.65 1.618.434.445.96.667 1.58.667z" _fill="#000" fill-rule="nonzero"/>'
  }
})
